import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      redirect: "/index",
    },
    {
      path: "/home",
      name: "Home",
      component: () => import("../views/home.vue"),
      children: [
        {
          path: "/index",
          title: '主页',
          component: () => import("../views/pages/index.vue"),
        },
        {
          path: "/conferenceSpace",
          title: '会议场所',
          component: () => import("../views/pages/conferenceSpace/index.vue"),
        },
        {
          path: "/conferenceSpaceDetail",
          title: '酒店详情',
          component: () => import("../views/pages/conferenceSpace/detail.vue"),
        },
        {
          path: "/conferenceSpaceVanueDetail",
          title: '会场详情',
          component: () => import("@/views/pages/conferenceSpace/vanueDetail.vue"),
        },
        {
          path: "/activityDetail",
          title: '活动详情',
          component: () => import("@/views/pages/activity/index.vue"),
        },
        {
          path: "/matchingService",
          title: '配套服务',
          component: () => import("../views/pages/matchingService/index.vue"),
        },
        {
          path: "/LoginInterface",
          title: '酒店入驻',
          component: () => import("../views/pages/LoginInterface/loginInterface.vue"),
        },
        {
          path: "/encyclopedia",
          title: '办会百科',
          component: () => import("../views/pages/encyclopedia/index.vue"),
        },
        {
          path: "/encyclopediaDetail",
          title: '办会百科详情',
          component: () => import("../views/pages/encyclopedia/detail.vue"),
        },
        {
          path: "/cooperative",
          title: '关于我们',
          component: () => import("../views/pages/cooperative/index.vue"),
        },
        {
          path: "/cooperativeDetail",
          title: '关于我们',
          component: () => import("../views/pages/cooperative/detail.vue"),
        },
        {
          path: "/aboutUs",
          title: '关于我们',
          component: () => import("../views/pages/aboutUs/index.vue"),
        },
        {
          path: "/aboutDetail",
          title: '关于我们详情',
          component: () => import("../views/pages/aboutUs/detail.vue"),
        },
        {
          path: "/customer",
          title: '大客户详情',
          component: () => import("../views/pages/customer/index.vue"),
        },
        {
          path: "/appCenter",
          title: '应用中心',
          component: () => import("../views/pages/appCenter/index.vue"),
        },
        {
          path: "/service",
          title: '配套服务中心',
          component: () => import("../views/pages/appCenter/service.vue"),
        },
        {
          path: "/xieyi",
          title: '用户协议',
          component: () => import("@/views/pages/xieyi.vue"),
        },
        {
          path: "/yinsi",
          title: '隐私政策',
          component: () => import("@/views/pages/yinsi.vue"),
        },
        {
          path: "/contactUs",
          title: '联系我们',
          component: () => import("@/views/pages/contactUs/index.vue"),
        },
        {
          path: "/cooperation",
          title: '商务合作',
          component: () => import("@/views/pages/contactUs/cooperation.vue"),
        },
        {
          path: "/login",
          title: '客户登录',
          component: () => import("@/views/pages/userPage/login.vue"),
        },
        {
          path: "/userHome",
          title: '用户首页',
          component: () => import("@/views/pages/userPage/home.vue"),
        },
        {
          path: "/infoPage",
          title: '用户首页',
          component: () => import("@/views/pages/userPage/infoPage.vue"),
        },
        {
          path: "/orderDetail",
          title: '订单详情',
          component: () => import("@/views/pages/userPage/detail.vue"),
        },
        {
          path: "/shop",
          title: '积分商城',
          component: () => import("@/views/pages/userPage/shop.vue"),
        },
        {
          path: "/shopDetail",
          title: '商品详情',
          component: () => import("@/views/pages/userPage/shopDetail.vue"),
        },
        {
          path: "/waresOrder",
          title: '积分订单',
          component: () => import("@/views/pages/userPage/waresOrder.vue"),
        },
        {
          path: "/waresRule",
          title: '积分规则',
          component: () => import("@/views/pages/userPage/waresRule.vue"),
        },
        {
          path: "/address",
          title: '客户地址',
          component: () => import("@/views/pages/userPage/address.vue"),
        },
      ],
    },
    {
      path: "/404",
      name: "404",
      component: () => import("../views/404.vue"),
    },
  ],
});
